import React, { useState, useEffect } from 'react';
import SideNavSelect, { SignOutContainer, SignOutText } from './SideNavSelect';
import SideNavIndividual, { StyledSvg } from './SideNavIndividual';
import SideNavOrg, { GroupTitle, LinkContainer } from './SideNavOrg';
import SignOutIcon from '../../../img/sprite/sign-out-icon.svg';
import { useLocation } from 'react-router';
import { orgMenuLinks, developerLinks } from './header/account-menu/menuLinks';
import ViewAccountsModal from './header/account-menu/ViewAccountsModal';
import SideNavSkeleton from './SideNavSkeleton';
import css from '../../../css/css-variables';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

function SideNavWrapper({
  linkedOrganizations,
  linkedOrgsPending,
  orgId,
  onLogOut,
  currentUser,
}) {
  const MenuViews = {
    SELECT: 'SELECT',
    INDIVIDUAL: 'INDIVIDUAL',
    ORG: 'ORG',
  };

  const [orgsLoading, setOrgsLoading] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [viewAccountsModal, setViewAccountsModal] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (linkedOrgsPending === 'idle') {
      setOrgsLoading(true);
    } else if (linkedOrgsPending === 'pending') {
      setOrgsLoading(true);
    } else if (linkedOrgsPending === 'success') {
      setOrgsLoading(false);
    } else if (linkedOrganizations.length === 0) {
      setOrgsLoading(false);
    } else {
      setOrgsLoading(false);
    }
  }, [linkedOrgsPending, linkedOrganizations]);

  const [view, setView] = useState(MenuViews.SELECT);

  useEffect(() => {
    if (orgId && !orgsLoading) {
      const currentOrg = linkedOrganizations.find(
        (org) => org.organizationId === orgId
      );
      setSelectedOrg(currentOrg);
      setView(MenuViews.ORG);
    } else if (orgId === undefined && !pathname.includes(orgId)) {
      setView(MenuViews.INDIVIDUAL);
    }
  }, [orgId, orgsLoading, pathname]);

  const showBackBtn = linkedOrganizations?.length > 0;

  const linkedOrgsWithoutSelected = linkedOrganizations?.filter(
    (org) => org.organizationId !== selectedOrg?.organizationId
  );
  const orgButtonLinks =
    view === 'ORG'
      ? linkedOrgsWithoutSelected?.slice(0, 2)
      : linkedOrgsWithoutSelected?.slice(0, 3);

  const showMoreOrgs = linkedOrganizations?.length > 3;

  const updatedOrgMenuLinks = {
    ...orgMenuLinks,
    linkGroup: orgMenuLinks.linkGroup.map((group) => ({
      ...group,
      links: group.links.filter((link) => link.name !== 'Billing'),
    })),
  };

  const handleSelectOrg = (org) => {
    if (org) {
      setView(MenuViews.ORG);
      setSelectedOrg(org);
    }
  };

  return (
    <div data-qa-hook="side-nav-wrapper" style={{ marginTop: '20px' }}>
      <div>
        {orgsLoading && <SideNavSkeleton />}
        {!orgsLoading && (
          <>
            {/* INDIVIDUAL VIEW */}
            {view === 'INDIVIDUAL' && (
              <SideNavIndividual
                pathname={pathname}
                showBackBtn={showBackBtn}
                loading={orgsLoading}
                view={view}
                setView={setView}
                currentUser={currentUser}
              />
            )}
            {/* ORG VIEW */}
            {view === 'ORG' && (
              <SideNavOrg
                selectedOrg={selectedOrg}
                pathname={pathname}
                updatedOrgMenuLinks={updatedOrgMenuLinks}
                showBackBtn={showBackBtn}
                view={view}
                setView={setView}
              />
            )}
            {/* SELECT VIEW */}
            {linkedOrganizations?.length > 0 && (
              <SideNavSelect
                view={view}
                setView={setView}
                menu={MenuViews}
                pathname={pathname}
                showMoreOrgs={showMoreOrgs}
                linkedOrganizations={linkedOrganizations}
                orgButtonLinks={orgButtonLinks}
                loading={orgsLoading}
                handleSelectOrg={handleSelectOrg}
                setSelectedOrg={setSelectedOrg}
                setViewAccountsModal={() => setViewAccountsModal(true)}
                onLogOut={onLogOut}
              />
            )}
            <SignOutContainer>
              <button
                data-tracking-component="button"
                data-tracking-id="nav-sign-out-btn"
                data-qa-hook="nav-sign-out-btn"
                type="button"
                onClick={onLogOut}
                style={{
                  fontSize: '14px',
                  color: css.colors.Progress,
                  background: 'transparent',
                  display: 'flex',
                  gap: '4px',
                }}
              >
                <StyledSvg marginRight="0" width="18px" height="18px">
                  <use href={`#${SignOutIcon.id}`} />
                </StyledSvg>
                <SignOutText>Sign Out</SignOutText>
              </button>
            </SignOutContainer>
          </>
        )}
      </div>
      {viewAccountsModal && (
        <ViewAccountsModal
          show={viewAccountsModal}
          onClose={() => setViewAccountsModal(false)}
          linkedOrganizations={linkedOrganizations}
        />
      )}
    </div>
  );
}

export default SideNavWrapper;
